import "../../assets/scss/main.scss";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { getAttendeesForCurrentRound } from "../../data/httpClient";
import { CloseModalIcon } from "../CloseModalIcon";

interface StatsModalProps {
  close: () => void;
  roundId?: number;
}

export const StatsModal = ({ close, roundId }: StatsModalProps) => {
  const [totalRoundAttendees, setTotalRoundAttendees] = useState<number>(0);
  const [checkedInRoundAttendees, setCheckedInRoundAttendees] =
    useState<number>(0);
  const navigate = useNavigate();
  const { tournamentId } = useParams();

  useEffect(() => {
    (async () => {
      const totalAttendees =
        roundId !== undefined
          ? (await getAttendeesForCurrentRound?.(roundId)) ?? []
          : [];

      const checkedInAttendees = totalAttendees.filter(
        (x: { checkedIn: boolean }) => x.checkedIn
      );

      setTotalRoundAttendees(totalAttendees.length);
      setCheckedInRoundAttendees(checkedInAttendees.length);
    })();
  }, [roundId]);

  const checkedInPercentage =
    totalRoundAttendees > 0
      ? Math.round((checkedInRoundAttendees / totalRoundAttendees) * 100)
      : 0;

  return (
    <div className="checkInStatsModalContent">
      <CloseModalIcon onRequestClose={close} />
      <div
        className="statsGrid"
        role="group"
        aria-label="Round attendance stats"
      >
        <div className="statCard">
          <p className="statLabel">Total Attendees</p>
          <p className="statValue">{totalRoundAttendees}</p>
        </div>

        <div className="statCard">
          <p className="statLabel">Checked In</p>
          <p className="statValue">{checkedInRoundAttendees}</p>
        </div>

        <div className="statCard">
          <p className="statLabel">Checked In %</p>
          <p className="statValue">{checkedInPercentage}%</p>
        </div>
      </div>
      {typeof roundId === "number" && tournamentId ? (
        <button
          type="button"
          className="anchorButton"
          onClick={() =>
            navigate(
              `/tournaments/${tournamentId}/admin/NotCheckedInAttendeesPage/${roundId}`
            )
          }
        >
          View Not Checked In Attendees
        </button>
      ) : (
        <button
          type="button"
          className="anchorButton"
          disabled
          aria-disabled="true"
        >
          View Not Checked In Attendees
        </button>
      )}
    </div>
  );
};
